import { RefObject } from "react";
import { ProgramPhase } from "@platform/types/dashboard.types";
import { Loader } from "@shared/ui/Loader";
import { ProgramPhasesTimeline } from "./ProgramPhasesTimeline";
import { useProgram } from "../../hooks/useProgram";

export type Props = {
  timelineRef: RefObject<HTMLDivElement>;
  selectedPhase: ProgramPhase | undefined;
  setSelectedPhase: (phase: ProgramPhase) => void;
};

export function ProgramPhasesTimelineContainer({
  timelineRef,
  selectedPhase,
  setSelectedPhase,
}: Props) {
  const { phases } = useProgram();

  if (!phases || !selectedPhase) return <Loader />;

  return (
    <ProgramPhasesTimeline
      timelineRef={timelineRef}
      selectedPhase={selectedPhase}
      phases={phases}
      setSelectedPhase={setSelectedPhase}
    />
  );
}

export default ProgramPhasesTimelineContainer;
